import React                from 'react'
import { 
    Container, 
    Content,
    Details,
}                           from './component'

const ServicesDetails = () => {
    return (
        <Container>
            <Content>
                <Details />
            </Content>
        </Container>
    )
}

export default ServicesDetails
